import Vue from 'vue';
import Router from 'vue-router';
import MainLayout from './layouts/MainLayout.vue';
import Start from './views/Start.vue';
import Portfolio from './views/Portfolio.vue';
import Search from './views/Search.vue';
import CreateDocument from './views/CreateDocument.vue';
import EditDocument from './views/EditDocument.vue';
import ImportSie from './views/ImportSie.vue';
import EditSie from './views/EditSie.vue';
import SidebarCompany from './views/SidebarCompany.vue';
import SidebarPortfolio from './views/SidebarPortfolio.vue';
import CardOverview from './views/CardOverview.vue';
import CardCompass from './views/CardCompass.vue';
import CardCompassYears from './views/CardCompassYears.vue';
import CardProfitLoss from './views/CardProfitLoss.vue';
import CardProfitLossDiagram from './views/CardProfitLossDiagram.vue';
import CardValuation from './views/CardValuation.vue';
import CardBalance from './views/CardBalance.vue';
import CardSie from './views/CardSie.vue';
import CardDocuments from './views/CardDocuments.vue';

const QuickBk =         () => import(/* webpackChunkName: "c1" */ `@/presentations/Quick${process.env.VUE_APP_BRAND}.vue`);
const Valuation =       () => import(/* webpackChunkName: "c1" */ '@/presentations/Valuation.vue');
const Company =         () => import(/* webpackChunkName: "c1" */ `@/presentations/Company${process.env.VUE_APP_BRAND}.vue`);
const Competitors =     () => import(/* webpackChunkName: "c1" */ `@/presentations/Competitors${process.env.VUE_APP_BRAND}.vue`);
const YearReview =     () => import(/* webpackChunkName: "c1" */ `@/presentations/YearReview.vue`);

const QuickGt =         () => import(/* webpackChunkName: "c2" */ '@/presentations/QuickGT.vue');
const ClosingMeeting =  () => import(/* webpackChunkName: "c2" */ '@/presentations/ClosingMeetingGT.vue');
const PreClosingMeeting =  () => import(/* webpackChunkName: "c2" */ '@/presentations/PreClosingMeetingGT.vue');
const FutureMeeting =  () => import(/* webpackChunkName: "c2" */ '@/presentations/FutureMeetingGT.vue');
const YearEndMeeting =  () => import(/* webpackChunkName: "c2" */ '@/presentations/YearEndMeetingGT.vue');

Vue.use(Router);

const router: Router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/start',
      component: MainLayout,
      children: [
        {
          path: '/start',
          name: 'start',
          components: {main: Start},
        },
        {
          path: '/portfolio',
          name: 'portfolio',
          components: {main: Portfolio, sidebar: SidebarPortfolio},
        },
        {
          path: '/document/edit',
          name: 'editdocument',
          components: {main: EditDocument},
        },
        {
          path: '/document',
          name: 'document',
          components: {main: CreateDocument},
        },
        {
          path: '/importsie',
          name: 'importsie',
          components: {main: ImportSie},
        },
        {
          path: '/editsie',
          name: 'editsie',
          components: {main: EditSie},
        },
        {
          path: '/search',
          name: 'search',
          components: {main: Search},
        },
        {
          path: '/:OrgNr/overview',
          name: 'overview',
          // tslint:disable-next-line: max-line-length
          components: {main: CardOverview, sidebar: SidebarCompany},
        },
        {
          path: '/:OrgNr/compass',
          name: 'compass',
          components: {main: CardCompass, sidebar: SidebarCompany},
        },
        {
          path: '/:OrgNr/compassyears',
          name: 'compassyears',
          components: {main: CardCompassYears, sidebar: SidebarCompany},
        },
        {
          path: '/:OrgNr/profitlossdiagram',
          name: 'profitlossdiagram',
          components: {main: CardProfitLossDiagram, sidebar: SidebarCompany},
        },
        {
          path: '/:OrgNr/valuation',
          name: 'valuation',
          components: {main: CardValuation, sidebar: SidebarCompany},
        },
        {
          path: '/:OrgNr/profitloss',
          name: 'profitloss',
          components: {main: CardProfitLoss, sidebar: SidebarCompany},
        },
        {
          path: '/:OrgNr/balance',
          name: 'balance',
          components: {main: CardBalance, sidebar: SidebarCompany},
        },
        {
          path: '/:OrgNr/sie',
          name: 'sie',
          components: {main: CardSie, sidebar: SidebarCompany},
        },
        {
          path: '/:OrgNr/documents',
          name: 'documents',
          components: {main: CardDocuments, sidebar: SidebarCompany},
        },
      ],
    },
    {
      path: '/presentation/quick/:OrgNr',
      name: 'presentation-quick',
      component: process.env.VUE_APP_BRAND === 'BK' ? QuickBk : QuickGt,
    },
    {
      path: '/presentation/valuation/:DocumentId',
      name: 'presentation-valuation',
      component: Valuation,
    },
    {
      path: '/presentation/company/:DocumentId',
      name: 'presentation-company',
      component: Company,
    },
    {
      path: '/presentation/competitors/:DocumentId',
      name: 'presentation-competitors',
      component: Competitors,
    },
    {
      path: '/presentation/closingmeeting/:DocumentId',
      name: 'presentation-closingmeeting',
      component: ClosingMeeting,
    },
    {
      path: '/presentation/preclosingmeeting/:DocumentId',
      name: 'presentation-preclosingmeeting',
      component: PreClosingMeeting,
    },
    {
      path: '/presentation/futuremeeting/:DocumentId',
      name: 'presentation-futuremeeting',
      component: FutureMeeting,
    },
    {
      path: '/presentation/yearendmeeting/:DocumentId',
      name: 'presentation-yearendmeeting',
      component: YearEndMeeting,
    },
    {
      path: '/presentation/yearreview/:DocumentId',
      name: 'presentation-yearreview',
      component: YearReview,
    },
    {
      path: '/admin',
      name: 'admin',
      component: () => import(/* webpackChunkName: "admin" */ './views/Admin.vue'),
    },
  ],
});

router.beforeEach( (to: any, from: any, next: any) => {
  return next();
});

export default router;
